(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digital-home"] && !Shopify.designMode) return;
  try {
    
class DigitalPartsFinder extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.form = this.querySelector('form');
    this.results = this.querySelector('[data-finder-results]');
    this.status = this.querySelector('[data-finder-status]');
    this.empty = this.querySelector('[data-finder-empty]');
    this.cards = [...this.querySelector('template').content.querySelectorAll('[data-finder-card]')];
    this.form.addEventListener('submit', event => {
      event.preventDefault();
      if (!this.form.reportValidity()) return;
      const model = this.form.elements.model.value;
      const category = this.form.elements.category.value;
      const budgetValue = this.form.elements.budget.value.trim();
      const budget = budgetValue === '' ? Infinity : Number(budgetValue) * 100;
      const matches = this.cards.filter(card =>
        card.dataset.collections.split(',').includes(model) &&
        (category === 'all' || card.dataset.collections.split(',').includes(category)) &&
        Number(card.dataset.price) <= budget
      ).sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
      this.results.replaceChildren(...matches.slice(0, 6).map(card => card.cloneNode(true)));
      this.empty.hidden = matches.length > 0;
      this.status.textContent = matches.length ?
        this.dataset.found.replace('[count]', Math.min(matches.length, 6)) : this.dataset.none;
      this.querySelector('[data-finder-output]').hidden = false;
    });
    this.form.addEventListener('reset', () => {
      this.results.replaceChildren();
      this.querySelector('[data-finder-output]').hidden = true;
    });
  }
}
if (!customElements.get('digital-parts-finder')) customElements.define('digital-parts-finder', DigitalPartsFinder);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
